import React from "react";
import Card from "../Card";
import './styles.scss'

const Projetos = () => {
    return(
        <div className="ProjetoConteiner">
            <h5>
                Principais<br/>
                <strong>Projetos</strong>
            </h5>
            <div className="Cards">
                <a href="https://netflix-clone-react-js-iota.vercel.app" target="_blank" rel="noreferrer">
                    <Card foto="NetflixClone" mensagem="Clone Netflix"/>
                </a>
                <a href="https://sosa-movie.vercel.app" target="_blank" rel="noreferrer">
                    <Card foto="SosaAnime" mensagem="Sosa Anime"/>
                </a>
            </div>
            <div className="GitLink">
                <a href="https://github.com/FeSoSa?tab=repositories" target="_blank" rel="noreferrer">Ver Repositório Completo</a>
            </div>
        </div>
    );
}
export default Projetos